import {IonButton,  IonIcon} from '@ionic/react'
import {logoLinkedin, logoTwitter, mail, logoGithub, logoMedium} from 'ionicons/icons';

function MySocials(){
    return (
      <div className="ion-padding-end">
        <IonButton
          size="small"
          className="ion-button"
          href="https://www.linkedin.com/in/cameronelowry/"
          target="_blank"
        >
          <IonIcon icon={logoLinkedin} />
        </IonButton>
        <IonButton
          size="small"
          className="ion-button"
          href="https://twitter.com/cameronelowry"
          target="_blank"
        >
          <IonIcon icon={logoTwitter} />
        </IonButton>
        <IonButton
          size="small"
          className="ion-button"
          href="mailto:cameronelowry@gmail.com"
          target="_blank"
        >
          <IonIcon icon={mail} />
        </IonButton>
        <IonButton
          size="small"
          className="ion-button"
          href="https://github.com/cameronelow"
          target="_blank"
        >
          <IonIcon icon={logoGithub} />
        </IonButton>
        <IonButton
          size="small"
          className="ion-button"
          href="https://medium.com/@cameronelowry"
          target="_blank"
        >
          <IonIcon icon={logoMedium} />
        </IonButton>
      </div>
    );
}

export default MySocials